import React, { Component } from 'react';

import { connect } from 'react-redux'
import { Redirect } from "react-router-dom";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import LogoChr from "./assets/logo-chr.png"

import { withStyles } from '@material-ui/core/styles';

import LockOpen from '@material-ui/icons/LockOpen';
import store from './Redux';

import Fade from '@material-ui/core/Fade';

import { doPost, select } from './Redux/Actions'

const styles = theme => ({
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    logoContainer: {
        padding: 10,
        background: "#0165a1"
    },
    logoImg: {
        width: "100%"
    }
});


class Login extends Component {

    state = {
        username: '',
        password: '',
        authSuccess: false,
        isLoading: false
    }

    componentWillMount() {
        this.unsubscribe = store.subscribe(() => {
                var state = select(store.getState(), "user")
                this.setState({...state})
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });
    };

    login = () => {
        if(!this.state.username || !this.state.password) {
            alert("Benutzername oder Passwort ist fehlen.")
            return
        }
        this.props.doLogin({username: this.state.username, password: this.state.password})
    }

    render() {

        var {
            classes
        } = this.props

        if (this.state.authSuccess) {
            return <Redirect to={"/"} />;
        }

        var {
            isLoading
        } = this.state

        if (isLoading) {
            return (
                <Fade in={true}>
                    <div className="login-container">
                        <Card className="loader">
                            <CircularProgress size={50} />
                        </Card>
                    </div>
                </Fade>
            )
        }

        return (
            <div className="login-container">
                <Card id="login">
                    <div className={classes.logoContainer}>
                        <img src={LogoChr} className={classes.logoImg} />
                    </div>
                    <CardContent>
                        <Input
                            placeholder="Benutzername"
                            id="username"
                            label="Benutzername"
                            value={this.state.username}
                            onChange={this.handleChange('username')}
                            fullWidth
                            disableUnderline
                            autoComplete="off"
                        />
                        <Divider />
                        <Input
                            placeholder="Passwort"
                            id="password"
                            label="Passwort"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleChange('password')}
                            fullWidth
                            disableUnderline
                        />
                    </CardContent>
                    <Divider />
                    <CardActions className="cardAction">
                        <Button type="submit" onClick={this.login}><LockOpen /> Anmelden</Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    data: state.user
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLogin: (loginData) => dispatch(doPost("USER", "auth", loginData)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Login));



// WEBPACK FOOTER //
// ./src/Login.js